import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const XNoIcon = forwardRef<any, any>((props, ref) => {
  const width = "48";
  const height = "48";
  const viewBox = `0 0 ${width} ${height}`;

  return (
    <Icon viewBox={viewBox} {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#DF2F26"
      />
      <g filter="url(#filter0_dd_21562_96130)">
        <path
          d="M29.1001 24.0018L38.1332 14.9685C38.4858 14.6143 38.4858 14.0329 38.1332 13.6803L34.3223 9.86931C33.9697 9.51668 33.39 9.51668 33.0357 9.86931L24.0011 18.9042L14.9608 9.86451C14.6066 9.51188 14.0268 9.51188 13.6742 9.86451L9.86332 13.6771C9.5091 14.0281 9.5091 14.6079 9.86332 14.9653L18.9028 24.0034L9.86572 33.0392C9.5147 33.3902 9.5147 33.9715 9.86572 34.3258L13.6766 38.1368C14.0308 38.4878 14.6137 38.4878 14.9648 38.1368L23.9995 29.1026L33.0293 38.1328C33.382 38.4854 33.9649 38.4854 34.3175 38.1328L38.13 34.3202C38.481 33.9691 38.481 33.3878 38.13 33.032L29.1001 24.0018Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_21562_96130"
          x="1.59766"
          y="2.60004"
          width="44.8008"
          height="44.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_21562_96130"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_21562_96130"
            result="effect2_dropShadow_21562_96130"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_21562_96130"
            result="shape"
          />
        </filter>
      </defs>
    </Icon>
  );
});

export { XNoIcon };
